<template>
  <v-select
    :items="planos"
    item-text="text"
    item-value="value"
    v-model="planosSelecionados"
    label="Plano do Estabelecimento"
    multiple
    chips
  />
</template>

<script>
export default {
  name: 'FiltroPlano',
  data() {
    return {
      planos: [
        {
          text: 'Livre',
          value: 'livre'
        },
        {
          text: 'Prata',
          value: 'prata'
        },
        {
          text: 'Ouro',
          value: 'ouro'
        },
        {
          text: 'Diamante',
          value: 'diamante'
        },
        {
          text: 'Safira',
          value: 'safira'
        }
      ],
      planosSelecionados: ['livre', 'prata', 'ouro', 'diamante', 'safira']
    }
  },
  mounted() {
    this.emitirPlanosSelecionados()
  },
  watch: {
    planosSelecionados() {
      this.emitirPlanosSelecionados()
    }
  },
  methods: {
    emitirPlanosSelecionados() {
      this.$emit('filtrar-planos', {
        planos_estabelecimento: this.planosSelecionados
      })
    }
  }
}
</script>
